/*
*  Seasons & episodes, newest season first (as on the previous site). Titles and descriptions are word-for-word.
*  To add an episode: upload it to YouTube, then add { number, title, youtubeId, description } to the right season.
*  youtubeId is the 11 characters after "watch?v=" (or after "youtu.be/") in the video's link.
*  A new season also needs a banner photo in public/images (see SETUP.md for the sizes).
*/

export const SEASONS = [
  {
    id: "season-three",
    name: "Season Three",
    banner: "season-3",
    episodes: [
      {
        number: 1,
        title: "Season 3 Intro",
        youtubeId: "-HhpaCtNzqM",
        description: "In this season opener, I reflect on the seismic shifts we’re seeing in the global art ecosystem, from the inaugural Art Basel in Doha—a sophisticated blend of art fair and biennale—to our very own upcoming debut at the Investec Cape Town Art Fair. For the first time, ARTdacity moves from the sidelines to the center stage as an exhibitor. Our booth may be just six square meters, but it is a space with the biggest heart, serving as a physical \"love letter\" to the contemporary African artists and creatives who inspire us every day.",
      },
      {
        number: 2,
        title: "Masekhaya",
        youtubeId: "sTmfB9W5lgQ",
        description: "This episode is a reflection on the roots that sustain us. I share stories of my childhood in Blackheath during the 1980s, the \"beautiful crazy\" of my mother—my first art teacher—who turned pillowcases into canvases, and the memory of my brother, who I carry with me every day. From an outreach ballet project that gave a seven-year-old girl a stage, to my current mission of dancing on point in 2026, I explore the idea that a dream delayed is never a dream denied. Masekhaya is my way of ensuring that art is no longer just \"something that hangs on rich people's walls,\" but a space where every African child feels they belong.",
      },
      {
        number: 3,
        title: "Chris Soal",
        youtubeId: "qZRof79vJQI",
        description: "Chris has a rare gift for transforming the overlooked—millions of single-use toothpicks, discarded beer bottle caps, and worn sandpaper—into writhing, tactile sculptures that bridge the gap between intuition and intention. In this episode of ARTdacity, we discuss his formative time at the RAW Academy in Dakar, the profound influence of luminaries like Koyo Kouoh and Otobong Nkanga, and his philosophy on \"perceptive capacity\"—the discipline of finding value in what society has already dismissed.",
      },
      {
        number: 4,
        title: "Nicola Brandt",
        youtubeId: "2lW1RkxnOD0",
        description: "Nicola takes us on a decade-long journey through her homeland, working with the legendary \"King of Print,\" Gerhard Steidl, to birth a project that is as much an academic inquiry as it is a visual soul-searching mission. We delve into the \"cosmic lottery\" of birth, the complexity of navigating a post-apartheid identity, and the hidden scars left on a landscape often mistaken for empty. From the haunting legacy of eugenics in Rehoboth to the \"God complex\" of landscape art inspired by the late Santu Mofokeng, this conversation bridges the gap between private and public memory.",
      },
      {
        number: 5,
        title: "From Modernist Masters to Hair Matters - Strauss & Co",
        youtubeId: "OiT-g_o3kbU",
        description: "I’m joined by art specialist Wilhelm and researcher Kirstie Pietersen to navigate this rich landscape—from the modernist legacy of Douglas Portway and the provocative, identity-driven performances of Steven Cohen, to a pan-African exploration of hair as a crown, a commodity, and a powerful vessel for history. We discuss the works of trailblazers like Tracey Rose, Hank Willis Thomas, and Adebunmi Gbadebo, uncovering how art serves as both a mirror and a catalyst for liberation.",
      },
      {
        number: 6,
        title: "Johannes Segogela",
        youtubeId: "qjCjD7QNJgE",
        description: "Johannes (1936–2018) was a master of wood sculpture whose work remains a powerful, if sometimes overlooked, pillar of the South African art landscape. Despite his presence in major global museums and a long history with the Goodman Gallery, Segogela is a reminder of how easily legendary African artists can slip into the digital shadows—even today, the internet erroneously lists him as still living. In this episode, we explore his dogmatic, tender, and often startling world: a place where angels film the tragedies of the African Renaissance and the struggle between sin and salvation is carved into every figure.",
      },
      {
        number: 7,
        title: "A Protea Is Not a Flower",
        youtubeId: "-31SyFa3M1Q",
        description: "In this segment, we stand before a staggering 1:1 ratio mural of the facade of John Vorster Square, the notorious Johannesburg police station. This fragment of architecture serves as a backdrop to the poetry of Don Mattera, specifically his 1970s work \"Fallen Fruit,\" dedicated to the mother of anti-apartheid activist Ahmed Timol. As we walk through the monochromatic photography offset by these visceral red surfaces, we aren't just looking at art; we are questioning the very mechanics of history: Who records it? Who is pushed to the periphery? And how do we celebrate the \"grandness\" of figures like Bessie Head, who lived in humble poverty but left a legacy that is computationally priceless?",
      },
      {
        number: 8,
        title: "Cape Town Art Fair 2026",
        youtubeId: "N8x_pshI0f8",
        description: "I sat down with art historian Liese van der Watt to discuss her \"labor of love and relief,\" the book We, The People, which traces 30 years of South African art and democracy. We also welcome home Rita Mawuena Benissan, whose monumental atrium commission at the Zeitz MOCAA left patrons in tears, as she reflects on the profound \"coronation\" of culture and the enduring legacy of Koyo Kouoh.",
      },
      {
        number: 9,
        title: "Danda Jaroljmek & Sujay Shah",
        youtubeId: "_FM4pHt2iGg",
        description: "Jo-Ann sits down with the team from Nairobi’s Circle Art Gallery to discuss their return to the Investec Cape Town Art Fair. Sujay Shah reveals the evolution of his practice—moving from satirical takes on colonial trophy hunting to complex, ambiguous \"hybrid\" and \"cyborg\" figures that challenge the viewer to look closer. Danda shares the gallery’s 14-year journey and the vital importance of building cross-continental collector bases and critical dialogue within Africa.",
      },
      {
        number: 10,
        title: "Franziska Wendler & Gabrielle Kruger",
        youtubeId: "-TUN-uYEgbY",
        description: "A deep dive into the \"radical experimentalism\" of Gabrielle Kruger’s studio. Gabrielle explains her unique process of peeling and weaving paint into 3D sculptural \"skins\" and \"hanging landscapes\". Franziska discusses the gallery’s long-standing connection between Leipzig and Cape Town and their 2026 booth featuring Birgit Brenner’s powerful social installations.",
      },
      {
        number: 11,
        title: "Franziska Wendler & Brett Seiler",
        youtubeId: "Vd_VpuV7J9I",
        description: "Fresh from his residency in Germany, Brett Charles Seiler discusses his life as a \"swallow,\" chasing the sun between Europe and South Africa. Brett and Franziska explore the creation of \"Low Budget Love Story\" and how his raw, poetic use of materials like bitumen and text continues to capture urgent, intimate moments.",
      },
      {
        number: 12,
        title: "Cyril Moumen",
        youtubeId: "EfEKCBvptaw",
        description: "Jo-Ann connects with Cyril Moumen to explore the \"nomadic\" spirit of Gallery Nosco. After relocating his program from London to the South of France and Brussels, Cyril brings a globally-minded presentation to Cape Town centered on the 2026 theme of \"Appropriation\".",
      },
      {
        number: 13,
        title: "Franziska Wendler",
        youtubeId: "XxG9sSBHfj0",
        description: "Guest: Franziska Wendler (Director, Galerie EIGEN + ART) The Conversation: Jo-Ann connects with Franziska Wendler to discuss a historic milestone: the gallery’s participation in the inaugural edition of Art Basel Doha. This episode focuses on the presentation of Neo Rauch, the most prominent figure of the New Leipzig School and one of Germany’s most influential living painters.",
      },
      {
        number: 14,
        title: "Thebe Magugu",
        youtubeId: "7Pj__MJSpVQ",
        description: "Jo-Ann Strauss hosts a landmark celebration at the iconic \"Pink Lady\" of Cape Town—the Belmond Mount Nelson—to launch the Thebe Magugu Suite and Magugu House. In this episode, LVMH Prize winner Thebe Magugu reflects on a decade of his brand and his mission of \"Afro-encyclopedic\" fashion: using cloth as a powerful tool for preservation, advocacy, and memory.",
      },
      {
        number: 15,
        title: "Mr. Philip Boyd",
        youtubeId: "llpTiz_Zozk",
        description: "In this deeply moving episode, Jo-Ann Strauss reunites with the man who first opened her eyes to the world of art. Philip Boyd, a towering figure in South African ballet, reflects on a career that spans the prestigious stages of CAPAB to the classrooms of Gugulethu. He recounts his transition from being a principal dancer performing roles like Albrecht in Giselle to becoming a mentor who brought \"Ballet for All\" to the townships during the height of Apartheid.",
      },
    ],
  },
  {
    id: "season-two",
    name: "Season Two",
    banner: "season-2",
    episodes: [
      {
        number: 1,
        title: "Season 2 Introduction",
        youtubeId: "P-f1wl8RPAA",
        description: "We reflect on the impact of the late Koyo Kouoh, a towering figure in African contemporary art. We reflect on her legacy and how her passing reshaped the season’s direction. The episode also spotlights the 3 South African galleries who have achieved international success at Art Basel and who are showing again this year. We also speak one of the founders of Africa Basel, a new platform amplifying African voices in the global art scene.",
      },
      {
        number: 2,
        title: "Jonathan Garnham of Blank Projects",
        youtubeId: "YtRoYxsJu-c",
        description: "I sit down with Jonathan Garnham of blank projects, a trailblazing Cape Town gallery known for its focus on abstraction. We talk about his journey from artist to gallerist, the challenges of showing at Art Basel, and what it takes to put African art on the global stage.",
      },
      {
        number: 3,
        title: "Liza Essers of Goodman Gallery",
        youtubeId: "FIeEfbo-OiM",
        description: "I speak with Liza Essers, owner of Goodman Gallery, about her remarkable journey from economics and film into the art world. We explore how she’s helped shape South Africa’s art ecosystem, taken African voices to the global stage, and what to expect from her booth at Art Basel this year -including works by El Anatsui, Shirin Neshat, and the next generation of African talent.",
      },
      {
        number: 4,
        title: "Marc Barben of Stevenson",
        youtubeId: "nS24qSu4l_Q",
        description: "Marc Barben of Stevenson speaks about the gallery’s collective model, curating for Art Basel, and how a diverse team brings fresh energy to their programme. From historic works like a rare 1947 Ernest Mancoba to new pieces by Penny Siopis, Portia Zvavahera, and Simphiwe Ndzube, we unpack what’s heading to Basel -and how South African galleries are shaping the global art scene.",
      },
      {
        number: 5,
        title: "Benjamin Fueglister of Africa Basel",
        youtubeId: "Rrmqb7sIfRA",
        description: "Benjamin Fueglister, co-founder of the newly launched Africa Basel chats to us about his ambitious new fair spotlighting contemporary African art during one of the world’s biggest art weeks. We explore the motivations behind its creation, the challenges African galleries face in global markets, and how this fair hopes to carve out a bold new space in Basel’s historic heart.",
      },
      {
        number: 6,
        title: "Mandla Sibeko",
        youtubeId: "hIvRqhOwszg",
        description: "This week on ARTdacity I spoke to Mandla Sibeko who is the person behind Joburg Art Fair as well as BMW Art Generation. He has made a huge impact on an entire generation, but this impact extends far beyond collection to also curating events that really help to highlight the significance of art and the lifestyle that accompanies all things art.",
      },
      {
        number: 7,
        title: "BMW Young Collectors",
        youtubeId: "IOci9FpJY6k",
        description: "The BMW Young Collectors was started in 2020 as a network for emerging collectors to learn more through the likes of Mandla Sibeko an incredible art professional. I had the pleasure of joining Mandla and one of the collectors who was featured on the program Veronique Savigne at her incredible house in Cape Town as we chatted about what collecting means.",
      },
      {
        number: 8,
        title: "Albie Sachs",
        youtubeId: "T3H8A5b5ZTI",
        description: "In Episode 8 of ARTdacity Season 2, I sit down with Albie Sachs-freedom fighter, former Constitutional Court judge, and art lover -at his home in Clifton, just before he left for London for The Albies, a global human rights award ceremony. We discuss his exhibition Spring is Rebellious, currently showing at Zeitz MOCAA, and how art has shaped his lifelong pursuit of justice.",
      },
      {
        number: 9,
        title: "Anelisa Mangcu",
        youtubeId: "EWKy4DRqPB0",
        description: "In Episode 9 of ARTdacity Season 2, I sit down with the creative collective Half and Halve to unpack their exhibition, Klop Klop, hosted at Under the Aegis - a space founded by Anelisa Mangcu. We explore how identity, collaboration, and art intersect in their bold, thought-provoking practice.",
      },
      {
        number: 10,
        title: "Zolani Mahola",
        youtubeId: "0yawuY1JJGU",
        description: "In Episode 10 of ARTdacity Season 2, I sit down with Zolani Mahola- celebrated singer, storyteller, and creative force. Her roots in the Eastern Cape have profoundly shaped her artistry and worldview. We explore how her journey, music, and spirituality intertwine to create a deeply authentic expression of art and identity.",
      },
      {
        number: 11,
        title: "Kigali",
        youtubeId: "vGyfIuSEv1I",
        description: "As we close Season 2 of ARTdacity, I’m filled with gratitude for the incredible artists, curators, and listeners who’ve joined this journey -exploring how art shapes who we are and how we see the world. This season has deepened our conversations about creativity, identity, and connection across the continent and beyond.",
      },
      {
        number: 12,
        title: "Emotions of the Sun",
        youtubeId: "q2RmvAUeSrQ",
        description: "We're basking in the light and optimism of Veuve Clicquot's incredible exhibition, \"Emotions of the Sun,\" showing at the Youngblood Art Gallery until December 21st. I speak with three of the eight phenomenal, world-renowned photographers Christina de Middel, Newsha Tavakolian, and South Africa’s own Lindokuhle Sobekwa - who were given carte blanche to interpret the sun, the ultimate source of light and life, as their muse.",
      },
    ],
  },
  {
    id: "season-one",
    name: "Season One",
    banner: "season-1",
    episodes: [
      {
        number: 1,
        title: "Introduction",
        youtubeId: "QDDzKySeRkE",
        description: "Welcome to ARTdacity, a podcast exploring contemporary African art and its power to shape our lives. I’m Jo-Ann Strauss, and I invite you to join me in celebrating bold, visionary artists and their global impact.",
      },
      {
        number: 2,
        title: "Thania Petersen",
        youtubeId: "sHXsZ8KXlIQ",
        description: "I’m excited to speak with Thania Petersen, a brilliant contemporary African artist whose work explores identity and heritage. Her art creates a powerful space for reflection, and seeing her pieces at Art Basel left a lasting impact on me.",
      },
      {
        number: 3,
        title: "Jana Terblanche",
        youtubeId: "6VgvrFWsOYw",
        description: "I sit down with Jana Terblanche, curator at Southern Guild, to discuss her journey from Namibia to shaping the global art scene. We explore curation, creativity, and the rising influence of African artists as she prepares to open a group exhibition in Los Angeles.",
      },
      {
        number: 4,
        title: "Venice Biennale",
        youtubeId: "_IiQ5OMWgLc",
        description: "This episode explores the Venice Biennale’s growing connection to African artists and curators. With insights from Anelisa Mangcu, Kimberly Drew, Siwa Mgoboza, and more, we discuss representation, storytelling, and the future of African creativity on the global stage.",
      },
      {
        number: 5,
        title: "Breeze Yoko",
        youtubeId: "0UeOkjLxF4s",
        description: "In this episode of Artdacity, I speak with Breeze Yoko, a muralist and street artist using art as resistance and universal language. Fresh from a London residency, he shares his journey, the power of satire, and how African street art is making a global impact.",
      },
      {
        number: 6,
        title: "Lerato Nkosi",
        youtubeId: "XJj2IceVpcs",
        description: "I sit down with Lerato Nkosi, inaugural winner of the ANNA Award, to discuss her unique ink-based practice exploring identity and memory. With her latest exhibition at Gallery Momo, she’s redefining contemporary African art and amplifying important conversations.",
      },
      {
        number: 7,
        title: "Liese van der Watt",
        youtubeId: "4nyKDTMMefg",
        description: "In this episode, we sat down with Liese van der Watt, curator of We the People, an exhibition at the Norval Foundation that reflects on 30 years of South African democracy. Liese’s curation sparks vital conversations about identity, belonging, and resilience. Join us as we explore how art can question, inspire, and ultimately shape our shared narrative.",
      },
      {
        number: 8,
        title: "Art Education",
        youtubeId: "6w1Z_r3snFg",
        description: "I’m joined by Zain Nazier, who leads the Norval Foundation’s education program, and Evaan Jason Ferreira, a Zeitz MOCAA UWC Fellowship alumni, both of whom are shaping the future of art accessibility. Join us as we explore how investing in art education can empower the next generation of African artists and thinkers.",
      },
      {
        number: 9,
        title: "Stellenbosch Triennale",
        youtubeId: "g5UqVC1joBA",
        description: "We’re at the opening of the Stellenbosch Triennale, a visionary exhibition curated by Khanyisile Mbongwa - with the theme Ba'zinzile: A Rehearsal for Breathing. Join us as we explore how art can heal, provoke, and remind us to take a breath.",
      },
      {
        number: 10,
        title: "Cape Town Art Fair",
        youtubeId: "JDFAMkQl89w",
        description: "Art fairs serve as a dynamic platform for showcasing emerging and established artists while fostering connections between collectors, galleries, and the public. The Cape Town Art Fair, the largest of its kind in Africa, is a vibrant hub where local and international artists converge.",
      },
    ],
  },
];
